:host {
  height: auto;
  --info-box-min-height: 48px;
  --info-box-width: fit-content;
  --info-box-max-width: 830px;
  --info-box-icon-padding: calc(var(--spacer) * 1.5) calc(var(--spacer) * 2);
  --info-box-message-padding: calc(var(--spacer) * 2) 10px calc(var(--spacer) * 2) 0;
  --info-box-message-width: auto;
  --info-box-message-line-height: 21px;
  --info-box-message-font-weight: 400;
  padding: var(--spacer);
}

.info-box-container {
  display: flex;
  width: var(--info-box-width);
  border-radius: calc(var(--spacer) / 2);
  min-height: var(--info-box-min-height);
  max-width: var(--info-box-max-width);

  .message {
    --font-family: var(--font-family-secondary);
    font-size: var(--body-size-large);
    font-weight: var(--info-box-message-font-weight);
    color: var(--body-text-arrows-400);
    padding: var(--info-box-message-padding);
    line-height: var(--info-box-message-line-height);
    width: var(--info-box-message-width);
  }

  .icon {
    height: calc(var(--spacer) * 6);
    padding: var(--info-box-icon-padding);
    display: block;
  }

  .separator {
    display: flex;
    align-items: center;

    &:after {
      content: '';
      width: 1px;
      height: calc(100% - var(--spacer) * 2);
      background-color: var(--white-layout-101-outline-on-dark-background);
    }
  }

  .dismiss-button {
    margin: calc(var(--spacer) * 1.5) 10px 0 var(--spacer);
  }

  &.success {
    border: 1px solid var(--green-layout-100-primary-green);
    gz-icon::part(svgIcon) {
      fill: var(--green-layout-100-primary-green);
    }
  }

  &.informative {
    border: 1px solid var(--blue-layout-400-primary);
    gz-icon::part(svgIcon) {
      fill: var(--blue-layout-400-primary);
    }
  }

  &.warning {
    border: 1px solid var(--orange-layout-050-warning);
    gz-icon::part(svgIcon) {
      fill: var(--orange-layout-050-warning);
    }
  }

  &.error {
    border: 1px solid var(--red-layout-302-primary);
    gz-icon::part(svgIcon) {
      fill: var(--red-layout-302-primary);
    }
  }
}
